<template>
  <div>
    <div class="wrapper wrapper-full-page">
      <div class="full-page" :class="pageClass">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple | black" -->
        <div class="content">
          <div class="container">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageClass: {
      type: String,
      default: 'login-page'
    },
    backgroundColor: {
      type: String,
      default: 'orange'
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style>
</style>
